"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ForgotPasswordForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ForgotPasswordForm, _React$Component);

  function ForgotPasswordForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      _this.setState({
        email: event.target.value
      });
    });

    _this.state = {
      email: ''
    };
    return _this;
  }

  var _proto = ForgotPasswordForm.prototype;

  /* TODO: Error handling, once the API has been implemented */
  _proto.render = function render() {
    var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        isFetching = _this$props.isFetching;
    var email = this.state.email;
    return /*#__PURE__*/React.createElement(_semanticUiReact.Form, {
      onSubmit: function onSubmit() {
        return handleSubmit(email);
      },
      className: "login-form__form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      label: "Email",
      name: "email",
      type: "text",
      onChange: this.handleInputChange,
      disabled: isFetching
    }), /*#__PURE__*/React.createElement("div", {
      className: "login-form__buttons"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      type: "submit",
      loading: isFetching
    }, "Reset Password"), /*#__PURE__*/React.createElement(_reactRouterDom.NavLink, {
      to: "/login",
      className: "login-form__forgot-button"
    }, "Log In")));
  };

  return ForgotPasswordForm;
}(React.Component);

var _default = ForgotPasswordForm;
exports["default"] = _default;